/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {
    export class EgiftInsertTagValue implements angular.IDirective {
        restrict = 'A';
        scope = {};

        link = (scope: any, element: any) => {
            scope.insertingOption = {
                element: null,
                begin: null,
                end: null
            };

            element.find('iframe').contents().click(event => {
                scope.insertingOption.element = event.currentTarget;
            });

            element.find('input').blur(event => {
                scope.insertingOption.element = angular.element(event.currentTarget).controller('ngModel');
                scope.insertingOption.begin = event.currentTarget.selectionStart;
                scope.insertingOption.end = event.currentTarget.selectionEnd;
            });

            scope.$on('insertTag', (event, data) => {
                let sel, range;

                const wind = scope.insertingOption.element;
                const insertingData = `{${data.tagName}}`;

                if (wind && wind.getSelection) {
                    sel = wind.getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = sel.getRangeAt(0);
                        range.deleteContents();
                        range.insertNode(wind.createTextNode(insertingData));

                        //range.setStart(range.commonAncestorContainer, range.endOffset);
                        //range.collapse(true);
                        //sel.removeAllRanges();
                        //sel.addRange(range);

                        sel.collapse(range.commonAncestorContainer, range.endOffset);
                        if(wind.querySelector('table')) {
                            wind.querySelector('table').click();
                        }
                    }
                } else {
                    event.preventDefault();

                    if (!scope.insertingOption.element) return;

                    const insertingData = `{${data.tagName}}`;
                    const currentValue = scope.insertingOption.element.$viewValue || '';
                    scope.insertingOption.element.$setViewValue(`${currentValue.slice(0, scope.insertingOption.begin)}${insertingData}${currentValue.slice(scope.insertingOption.end)}`);
                    scope.insertingOption.element.$render();

                    scope.insertingOption.begin += insertingData.length;
                    scope.insertingOption.end += insertingData.length;
                }
                //event.preventDefault();

                scope.insertingOption = {
                    element: null,
                    begin: null,
                    end: null
                };
            });
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EgiftInsertTagValue();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('egiftInsertTagValue', EgiftInsertTagValue.factory());
}